module.exports = __webpack_public_path__ + "static/media/STAF_bokmål og lulesamisk_sekundærlogo_pos(svart).2e5b3d21.svg";